import clsx from 'clsx';
import type { FC } from 'react';

import { SECTIONS_IDS } from '../../../constants/sections';
import { ButtonLink } from '../common/ButtonLink';
import { Container } from '../common/Container';
import { Flex } from '../common/Flex';
import { Text } from '../common/Text';
import { TextLink } from '../common/TextLink';
import heroStyles from '../IntegrationsHero/IntegrationsHero.module.scss';
import ctaBannerStyles from '../IntegrationsMatchCtaBlock/IntegrationsMatchCtaBlock.module.scss';

import styles from './SolutionPageHero.module.scss';

export type SolutionPageHeroProps = {
  eyebrowLabel: string;
  headline: string;
  subheadline: string;
};

export const SolutionPageHero: FC<SolutionPageHeroProps> = (props) => {
  const { eyebrowLabel, headline, subheadline } = props;

  return (
    <Container className={heroStyles.root}>
      <div className={heroStyles.inner}>
        <Flex direction="column" alignItems="flexStart">
          <div className={heroStyles.sectionLabel}>
            <span className={heroStyles.sectionLabelLine} aria-hidden />

            <Text type="medium14" color="green" className={heroStyles.sectionEyebrow}>
              {eyebrowLabel}
            </Text>
          </div>

          <Text type="regular48" color="white" className={heroStyles.title}>
            {headline}
          </Text>

          <Text type="regular16" color="white50" whiteSpace="normal" className={heroStyles.description}>
            {subheadline}
          </Text>

          <Flex className={styles.actions} gap={12} wrap="wrap" alignItems="center">
            <ButtonLink
              href={`#${SECTIONS_IDS.contact}`}
              variant="primary"
              className={clsx(ctaBannerStyles.contactLinkPlain, ctaBannerStyles.contactSalesButton, styles.primaryCta)}
            >
              Get Started Now
            </ButtonLink>

            <TextLink
              href="/docs"
              target="_blank"
              rel="noopener noreferrer"
              isOutsideLink
              variant="green"
              type="medium16"
            >
              View Documentation
            </TextLink>
          </Flex>
        </Flex>
      </div>
    </Container>
  );
};
